import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Col, Space, Typography } from 'antd';

interface ForgotPasswordCardProps {
    forgotPasswordFormSlot: ReactNode;
}

export const ForgotPasswordCard = memo((props: ForgotPasswordCardProps) => {
    const { forgotPasswordFormSlot } = props;

    const { t } = useTranslation('auth');

    return (
        <Card
            className="auth-card"
            title={
                <Typography.Title level={2}>
                    {t('forgotPasswordCardTitle')}
                </Typography.Title>
            }
        >
            <Space
                className="full-width"
                direction="vertical"
                size={16}
            >
                <Col>
                    <Typography.Paragraph>
                        {t('forgotPasswordCardDescriptionLine1')}
                    </Typography.Paragraph>
                    <Typography.Paragraph>
                        {t('forgotPasswordCardDescriptionLine2')}
                    </Typography.Paragraph>
                </Col>
                {forgotPasswordFormSlot}
            </Space>
        </Card>
    );
});

ForgotPasswordCard.displayName = 'ForgotPasswordCard';
